import LocalForage from 'localforage';

const keyName = 'fow-logged-in';

export function setLogIn(cb) {
  LocalForage.setItem(keyName, true).then(cb());
};

export function setLogOut(cb) {
  LocalForage.setItem(keyName, false).then(cb());
};

export async function isLoggedIn(cb) {
  let isLogged = false;
  try {
    const value = await LocalForage.getItem(keyName);
    // This code runs once the value has been loaded
    // from the offline store.
    isLogged = value ? true:false;
  } catch (err) {
    // This code runs if there were any errors.
    console.error(err);
  }
  return isLogged;
};
